import { type ReactNode, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18n, initI18n } from './instance';

interface LocaleProviderProps {
  children: ReactNode;
}

/**
 * Initializes the i18n instance on mount and wires it into React.
 * Wrap the root of each app (shell + standalone portal).
 */
export function LocaleProvider({ children }: LocaleProviderProps) {
  // initI18n is safe to call multiple times; first call performs the init,
  // subsequent calls are no-ops.
  initI18n();

  useEffect(() => {
    // Keep <html lang="..."> in sync so screen readers and :lang() CSS rules
    // see the right locale.
    const apply = (lng: string | undefined) => {
      if (lng && typeof document !== 'undefined') {
        document.documentElement.lang = lng;
      }
    };
    apply(i18n.language);
    i18n.on('languageChanged', apply);
    return () => {
      i18n.off('languageChanged', apply);
    };
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
